import { render, staticRenderFns } from "./BlankV2.vue?vue&type=template&id=7e2ac13c"
import script from "./BlankV2.vue?vue&type=script&lang=js"
export * from "./BlankV2.vue?vue&type=script&lang=js"
import style0 from "./BlankV2.vue?vue&type=style&index=0&id=7e2ac13c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports